import React from 'react';
import { Navigate as NavigateRouter } from 'react-router-dom';
import { PAGES } from '@/pages/PAGE_CONSTANTS';
import useGetPageUrl from "@/routers/useGetPageUrl";

export interface NavigateProps {
  pageName?: PAGES;
  params?: { [key: string]: string };
  to?: string;
}
const Navigate = ({ pageName, params, to }: NavigateProps) => {
  let navigatePage: string | undefined = pageName;
  const getPageUrl = useGetPageUrl();
  if (to) {
    return <NavigateRouter to={to} replace={true} />;
  }

  if (pageName == null) throw new Error('Page name is required');

  navigatePage = getPageUrl({ pageName, params });
  return <NavigateRouter to={navigatePage} replace={true} />;
};

export default Navigate;
